import React from "react";
import styled from "styled-components";

const Title = styled.div`
  border-bottom: 1px solid #999999;
  max-width:500px
  margin-top:20px;
  margin-bottom:20px;
`;
const SectionTitle = ({ id, children }) => (
  <Title id={id}>{children}</Title>
);
export default SectionTitle;
